var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [
      _vm._v(
        _vm._s(
          _vm.$_.get(_vm.activity, "actorUser.name") || "Bilinmeyen Kullanıcı"
        ) +
          ' kullanıcısı "' +
          _vm._s(
            _vm.$_.get(_vm.activity, "payload.taskTitle") ||
              _vm.$_.get(_vm.activity, "payload.name") ||
              "Bilinmeyen Görev"
          ) +
          '" adlı görevi çöp kutusundan geri çıkardı.'
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }